<template>
  <div class="container mycontainer">
    <h1 class="style-h3">Mon profil</h1>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="formation-tab"
          data-toggle="tab"
          href="#formation"
          role="tab"
          aria-controls="formation"
          aria-selected="true"
          ><span>Mes formations</span></a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="account-tab"
          data-toggle="tab"
          href="#account"
          role="tab"
          aria-controls="account"
          aria-selected="false"
          ><span>Mon compte</span></a
        >
      </li>
      <li class="nav-item" v-if="snp['admin']">
        <a
          class="nav-link style-danger"
          id="formations-tab"
          data-toggle="tab"
          href="#formations"
          role="tab"
          aria-controls="formations"
          aria-selected="false"
          ><span>Formations</span></a
        >
      </li>
      <li class="nav-item" v-if="snp['admin']">
        <a
          class="nav-link style-danger"
          id="formateur-tab"
          data-toggle="tab"
          href="#formateur"
          role="tab"
          aria-controls="formateur"
          aria-selected="false"
          ><span>Formateurs</span></a
        >
      </li>
      <li class="nav-item" v-if="snp['admin']">
        <a
          class="nav-link style-danger"
          id="utilisateur-tab"
          data-toggle="tab"
          href="#utilisateur"
          role="tab"
          aria-controls="utilisateur"
          aria-selected="false"
          ><span>Utilisateurs</span></a
        >
      </li>
      <li class="nav-item" v-if="snp['admin']">
        <a
          class="nav-link style-danger"
          id="administration-tab"
          data-toggle="tab"
          href="#administration"
          role="tab"
          aria-controls="administration"
          aria-selected="false"
          ><span>Administration</span></a
        >
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="formation"
        role="tabpanel"
        aria-labelledby="formation-tab"
        style="max-height: 70vh !important; overflow-y: scroll"
      >
        <div class="row">
          <div
            class="col"
            style="border-right: 1px double #333; min-height: 60vh"
          >
            <h4 style="text-align: center">
              Calendrier des evenements à venir
            </h4>
            <FunctionalCalendar
              :date-format="'dd/mm/yyyy'"
              :isDateRange="false"
              :isDatePicker="false"
              :monthNames="[
                'Janvier',
                'Février',
                'Mars',
                'Avril',
                'Mai',
                'Juin',
                'Juillet',
                'Août',
                'Septembre',
                'Octobre',
                'Novembre',
                'Décembre',
              ]"
              :dayNames="['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di']"
              :markedDates="markedDatess"
            ></FunctionalCalendar>
          </div>
          <div class="col">
            <h4 style="text-align: center">Liste des évènements à venir</h4>
            <div class="row no-gutters">
              <div
                class="col-md-12 col-sm-12 col-xs-12"
                v-for="item in mesformations"
                :key="item.id"
              >
                <div class="card style-yellow">
                  <div class="card-body">
                    <h5 class="card-title">
                      Formation:
                      <b style="color: #34469b">{{ item.nomFormation }}</b>
                    </h5>
                    <div class="card-text">
                      <p>
                        <b>Date: </b
                        >{{
                          new Date(item.dateFormation)
                            .toISOString()
                            .replace("T", " ")
                            .substring(0, 10)
                        }}
                      </p>
                      <p><b>Format:</b> {{ item.formatFormation }}</p>
                      <h5 class="mb-1">
                        Numéro de la formation: {{ item.idformation }}
                      </h5>
                      <p>
                        N'oubliez pas de régler votre formation sur:
                        <a
                          class=""
                          target="_blank"
                          href="https://www.scorf.fr/facture"
                          style="color: #34469b !important"
                          >scorf.fr</a
                        >
                        en vous munissant du numéro de dossier présent ci-dessus
                      </p>
                      <b-button
                        class="btn btn-secondary"
                        block
                        variant="success"
                        target="_blank"
                        href="https://www.scorf.fr/facture"
                      >
                        Payer la formation</b-button
                      >
                      <b-button
                        class="btn btn-secondary"
                        block
                        variant="danger"
                        v-on:click="desinscription(item.id)"
                      >
                        Se désinscrire de la formation</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="account"
        role="tabpanel"
        aria-labelledby="account-tab"
      >
        <div class="row" style="margin-top: 2vh">
          <div class="col-12 col-sm-8 col-lg-6">
            <div class="form-group">
              <label for="">ID</label>
              <input
                type="text"
                id=""
                class="form-control"
                disabled
                :placeholder="userInf['Id']"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="form-group">
              <label for="">Nom</label>
              <input
                type="text"
                id=""
                class="form-control"
                disabled
                :placeholder="userInf['Nom']"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="form-group">
              <label for="">Prénom</label>
              <input
                type="text"
                id=""
                class="form-control"
                disabled
                :placeholder="userInf['Prenom']"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="form-group">
              <label for="">E-mail</label>
              <input
                type="text"
                id=""
                class="form-control"
                disabled
                :placeholder="userInf['Email']"
              />
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="form-group">
              <label for="">Téléphone</label>
              <input
                type="text"
                id=""
                class="form-control"
                disabled
                :placeholder="userInf['Telephone']"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 col-lg-3">
            <div class="form-group">
              <label for="">RPPS</label>
              <input
                type="text"
                id=""
                class="form-control"
                disabled
                :placeholder="userInf['Rpps']"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="formations"
        role="tabpanel"
        aria-labelledby="formations-tab"
        v-if="snp['admin']"
      >
        <b-button style="margin: 10px" v-on:click="showModalNewFormation"
          >Ajouter une formation</b-button
        >
        <b-table
          bordered
          hover
          fixed
          :items="Aformations"
          @row-clicked="myRowClickHandler"
          :fields="fieldsFormations"
        ></b-table>
      </div>
      <div
        class="tab-pane fade"
        id="formateur"
        role="tabpanel"
        aria-labelledby="formateur-tab"
        v-if="snp['admin']"
      >
        <b-button style="margin: 10px" v-on:click="showModalFormateur"
          >Ajouter un formateur</b-button
        >
        <div style="overflow-x: scroll">
          <b-table
            bordered
            @row-clicked="eventFormateur"
            :items="formateurs"
            :fields="fieldsFormateurs"
          ></b-table>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="utilisateur"
        role="tabpanel"
        aria-labelledby="utilisateur-tab"
        v-if="snp['admin']"
      >
        <div style="overflow-x: scroll">
          <b-table bordered :items="clients" responsive></b-table>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="administration"
        role="tabpanel"
        aria-labelledby="administration-tab"
        v-if="snp['admin']"
      >
        <b-card>
          <b-container class="bv-example-row">
            <b-row>
              <b-col style="margin-top: 3vh">
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="5"
                  label="Metier :"
                  label-for="metier"
                >
                  <b-form-select id="metier" :options="metiers"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <div>
                  <b-form-input
                    v-model="metier"
                    placeholder="Ajouter un metier"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col>
                <b-button v-on:click="addMetier">Ajouter</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col style="margin-top: 3vh">
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="5"
                  label="Disciplines :"
                  label-for="disciplines"
                >
                  <b-form-select
                    id="disciplines"
                    :options="disciplines"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <div>
                  <b-form-input
                    v-model="discipline"
                    placeholder="Ajouter une discipline"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col>
                <b-button v-on:click="addDiscipline">Ajouter</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col style="margin-top: 3vh">
                <b-form-group
                  label-cols-sm="4"
                  label-cols-lg="5"
                  label="Expertises :"
                  label-for="expertises"
                >
                  <b-form-select
                    id="expertises"
                    :options="expertises"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col>
                <div>
                  <b-form-input
                    v-model="expertise"
                    placeholder="Ajouter une expertise"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col>
                <b-button v-on:click="addExpertise">Ajouter</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>
      <b-modal
        ref="modal_formations"
        hide-footer
        title="Informations sur la formation"
        v-if="snp['admin']"
        size="xl"
      >
        <div class="modal-header">
          <h3>
            Formation :
            <b>{{ currentFormation.nomFormation }}</b> réalisée par
            <b>{{ currentFormation["Nom Prenom"] }}</b>
          </h3>
        </div>
        <div class="modal-body" style="max-height: 60vh; overflow-y: auto">
          <b-row class="text-center">
            <b-col cols="3"
              ><b-img :src="currentFormation.image" fluid></b-img>
            </b-col>

            <b-col cols="9">
              <b-tabs content-class="mt-3">
                <b-tab title="Informations">
                  <ul class="list-group text-left">
                    <li class="list-group-item">
                      Date :
                      <b>{{
                        new Date(
                          currentFormation.dateFormation
                        ).toLocaleDateString("fr-FR")
                      }}</b>
                    </li>
                    <li class="list-group-item">
                      Numéro de formation :
                      <b-form-input v-model="currentFormation.idformation">{{
                        currentFormation.idformation
                      }}</b-form-input>
                    </li>
                    <li class="list-group-item">
                      Durée :
                      <b-form-input v-model="currentFormation.dureeFormation">{{
                        currentFormation.dureeFormation
                      }}</b-form-input>
                    </li>
                    <li class="list-group-item">
                      Public :
                      <b-form-input
                        v-model="currentFormation.publicFormation"
                        >{{ currentFormation.publicFormation }}</b-form-input
                      >
                    </li>
                    <li class="list-group-item">
                      Format :
                      <b-form-input
                        v-model="currentFormation.formatFormation"
                        >{{ currentFormation.formatFormation }}</b-form-input
                      >
                    </li>
                    <li class="list-group-item">
                      Spécialitée :
                      <b-form-select
                        v-model="currentFormation.specialiteFormation"
                        cols="9"
                        id="nested-disciplines"
                        :options="disciplines"
                      ></b-form-select>
                    </li>
                    <li class="list-group-item">
                      Nombre d'inscripts :
                      <b>{{ currentFormation.nbinscripts }}</b>
                    </li>
                    <li class="list-group-item">
                      Descriptif :
                      <b-form-input
                        v-model="currentFormation.objectifFormation"
                        >{{ currentFormation.objectifFormation }}</b-form-input
                      >
                    </li>
                    <li class="list-group-item">
                      Détails :
                      <p>
                        <quill-editor
                          :content="currentFormation.details"
                          :options="editorOption"
                          v-model="currentFormation.details"
                        />
                      </p>
                    </li>
                    <li class="list-group-item">
                      <b-button
                        block
                        variant="success"
                        style="margin: 2px"
                        v-on:click="updateFormation"
                        >Sauvegarder les changements</b-button
                      >
                    </li>
                    <li class="list-group-item">
                      <b-button
                        block
                        variant="info"
                        style="margin: 2px"
                        v-on:click="showModalNewFormationDuplicate"
                        >Dupliquer la formation</b-button
                      >
                    </li>

                    <li class="list-group-item">
                      <b-button block style="margin: 2px" v-on:click="download"
                        >Extraire le fichier des inscripts</b-button
                      >
                    </li>
                  </ul>
                </b-tab>
                <b-tab title="Inscripts">
                  <div style="overflow-x: scroll">
                    <b-table
                      bordered
                      striped
                      hover
                      :items="currentFormation['inscripts']"
                    ></b-table>
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <b-row class="text-center" style="margin-top: 10px">
            <b-button block variant="danger" v-on:click="removeFormation"
              >Supprimer la formation</b-button
            >
          </b-row>
        </div>
      </b-modal>
      <b-modal
        size="xl"
        ref="modal-NewFormation"
        hide-footer
        title="Ajout d'une formation"
        v-if="snp['admin']"
      >
        <div class="scroll">
          <b-card bg-variant="light">
            <b-form-group
              label-cols-lg="0"
              label-size="sm"
              label-class="font-weight-bold pt-0"
              style="margin-top: 5vh !important"
            >
              <b-form-group
                label-cols-sm="3"
                label="Les 8 chiffres de la formation:"
                label-align-sm="right"
                label-for="nested-number"
              >
                <b-form-input
                  v-model="idfomration"
                  id="nested-number"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Nom de la formation:"
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-input
                  v-model="nomFormation"
                  id="nested-street"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                label="Formateur:"
                label-align-sm="right"
                label-for="nested-city"
              >
                <b-form-select
                  v-model="idFormationFormateur"
                  id="nested-metiers"
                  :options="formateursF"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                label="Date :"
                label-align-sm="right"
                label-for="example-datepicker"
              >
                <b-form-datepicker
                  id="example-datepicker"
                  v-model="dateFormation"
                  class="mb-2"
                ></b-form-datepicker>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                cols="3"
                label="Specialite:"
                label-align-sm="right"
                label-for="nested-disciplines"
              >
                <b-form-select
                  v-model="specialiteFormation"
                  cols="9"
                  id="nested-disciplines"
                  :options="disciplines"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Durée:"
                label-align-sm="right"
                label-for="nested-street0"
              >
                <b-form-input
                  v-model="dureeFormation"
                  id="nested-street0"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Public:"
                label-align-sm="right"
                label-for="nested-street1"
              >
                <b-form-input
                  v-model="publicFormation"
                  id="nested-street1"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Objectifs:"
                label-align-sm="right"
                label-for="nested-street2"
              >
                <b-form-input
                  v-model="objectifFormation"
                  id="nested-street2"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Format:"
                label-align-sm="right"
                label-for="nested-street3"
              >
                <b-form-input
                  v-model="formatFormation"
                  id="nested-street3"
                ></b-form-input>
              </b-form-group>
              <quill-editor
                :content="details"
                :options="editorOption"
                @change="onEditorChange2($event)"
                v-model="details"
              />
            </b-form-group>
            <b-row class="row">
              <b-col>
                <p>Ajouter une image pour la formation:</p>
                <input
                  type="file"
                  @change="previewImageFormation"
                  accept="image/*"
                />
                <p>
                  Progress: {{ uploadValue.toFixed() + "%" }}
                  <progress
                    id="progress"
                    :value="uploadValue"
                    max="100"
                  ></progress>
                </p>
              </b-col>
              <b-col v-if="imageData != null">
                <img
                  class="preview"
                  :src="picture"
                  style="
                    max-width: 100%;
                    max-height: 100%;
                    height: auto;
                    width: auto;
                  "
                />
                <br />
                <button
                  class="btn btn-primary btn-block"
                  @click="onUploadImageFormation"
                >
                  Televerser
                </button>
              </b-col>
            </b-row>
          </b-card>
          <div style="margin-bottom: 10px">
            <button
              v-if="
                this.nomFormation != '' &&
                this.idFormationFormateur != '' &&
                this.specialiteFormation != '' &&
                this.formatFormation != '' &&
                this.publicFormation != '' &&
                this.objectifFormation != '' &&
                this.dureeFormation != '' &&
                this.picture != null
              "
              class="mt-3 btn btn-primary btn-block"
              variant="outline-primary"
              @click="AddFormation"
            >
              Ajouter
            </button>
            <button
              v-if="
                !(
                  this.nomFormation != '' &&
                  this.idFormationFormateur != '' &&
                  this.specialiteFormation != '' &&
                  this.formatFormation != '' &&
                  this.publicFormation != '' &&
                  this.objectifFormation != '' &&
                  this.dureeFormation != '' &&
                  this.picture != null
                )
              "
              class="mt-3 btn btn-primary btn-block"
              variant="outline-primary"
              disabled
            >
              Remplissez tout les champs afin de valider la formation
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        ref="modal-Formateur"
        hide-footer
        size="xl"
        title="Ajout d'un formateur"
        style="height: 50vh; overflow: auto"
      >
        <div class="scroll">
          <b-card bg-variant="light">
            <b-form-group
              label-cols-lg="3"
              label="Informations"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="mb-0"
              style="margin-top: 5vh !important"
            >
              <b-form-group
                label-cols-sm="3"
                label="Nom:"
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-input v-model="nom" id="nested-street"></b-form-input>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                label="Prénom:"
                label-align-sm="right"
                label-for="nested-city2"
              >
                <b-form-input v-model="prenom" id="nested-city2"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Rôle:"
                label-align-sm="right"
                label-for="nested-city3"
              >
                <b-form-input v-model="role" id="nested-city3"></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="CV:"
                label-align-sm="right"
                label-for="nested-city"
              >
                <!--
                <b-form-textarea
                  v-model="cv"
                  id="nested-city"
                  rows="3"
                ></b-form-textarea>
                -->
                <quill-editor
                  :content="cv"
                  :options="editorOption"
                  @change="onEditorChange($event)"
                  v-model="cv"
                />
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Metier:"
                label-align-sm="right"
                label-for="nested-metiers"
              >
                <b-form-select
                  v-model="metierNew"
                  id="nested-metiers"
                  :options="metiers"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                label-cols-sm="3"
                cols="3"
                label="Disciplines:"
                label-align-sm="right"
                label-for="nested-disciplines"
              >
                <b-form-select
                  v-model="disciplineNew"
                  cols="9"
                  id="nested-disciplines"
                  :options="disciplines"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label-cols-sm="3"
                label="Expertise:"
                label-align-sm="right"
                label-for="nested-expertises"
              >
                <b-form-select
                  v-model="expertiseNew"
                  id="nested-expertises"
                  :options="expertises"
                ></b-form-select>
              </b-form-group>
            </b-form-group>
            <b-row class="row">
              <b-col>
                <p>Ajouter une image de profil pour un formateur:</p>
                <input
                  type="file"
                  @change="previewImageFormateur"
                  accept="image/*"
                />
                <p>
                  Progress: {{ uploadValueFormateur.toFixed() + "%" }}
                  <progress
                    id="progress"
                    :value="uploadValueFormateur"
                    max="100"
                  ></progress>
                </p>
              </b-col>
              <b-col v-if="imageDataFormateur != null">
                <img
                  class="preview"
                  :src="pictureFormateur"
                  style="
                    max-width: 100%;
                    max-height: 100%;
                    height: auto;
                    width: auto;
                  "
                />
                <br />
                <button
                  class="btn btn-block btn-primary"
                  @click="onUploadImageFormateur"
                >
                  Televerser
                </button>
              </b-col>
            </b-row>
          </b-card>
          <div>
            <button
              class="mt-3 btn btn-block btn-primary"
              v-if="
                this.nom != '' &&
                this.prenom != '' &&
                this.metierNew != '' &&
                this.disciplineNew != '' &&
                this.expertiseNew != '' &&
                this.pictureFormateur != null &&
                this.role != ''
              "
              block
              @click="AddFormateur"
            >
              Ajouter
            </button>
            <button
              class="mt-3 btn btn-block btn-primary"
              v-if="
                !(
                  this.nom != '' &&
                  this.prenom != '' &&
                  this.metierNew != '' &&
                  this.disciplineNew != '' &&
                  this.expertiseNew != '' &&
                  this.pictureFormateur != null &&
                  this.role != ''
                )
              "
              block
              disabled
            >
              Remplissez tout les champs afin de valider le formateur
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        ref="modal-sm"
        size="sm"
        title="Supprimer le formateur"
        @ok="removeFormateur($event)"
        >Supprimer le formateur {{ currentNomPrenom }} ?
      </b-modal>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import { FunctionalCalendar } from "vue-functional-calendar";
import XLSX from "xlsx";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  created: async function () {
    if (!firebase.auth().currentUser) {
      this.$router.push("/");
    } else {
      this.userInf = [];
      this.$firestore
        .collection("users")
        .doc(firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          this.snp = snapshot.data();
          //keys = [1, 2, 3]
          this.userInf["Id"] = firebase.auth().currentUser.uid;
          this.userInf["Email"] = firebase.auth().currentUser.email;
          this.userInf["Nom"] = snapshot.data()["nom"];
          this.userInf["Prenom"] = snapshot.data()["prenom"];
          this.userInf["Telephone"] = snapshot.data()["telephone"];
          if (snapshot.data()["salarie"]) {
            this.userInf["Rpps"] = snapshot.data()["rpps"];
          } else {
            this.userInf["Siret"] = snapshot.data()["siret"];
            this.userInf["Taille_ent"] = snapshot.data()["taille_ent"];
          }
          if (snapshot.data()["admin"]) {
            this.$firestore
              .collection("parametres")
              .doc("metiers")
              .get()
              .then((snapshot) => {
                this.metiers = snapshot.data();
              });
            this.$firestore
              .collection("parametres")
              .doc("expertises")
              .get()
              .then((snapshot) => {
                this.expertises = snapshot.data();
              });
            this.$firestore
              .collection("parametres")
              .doc("disciplines")
              .get()
              .then((snapshot) => {
                this.disciplines = snapshot.data();
              });
            this.$firestore
              .collection("formations")
              .get()
              .then((snapshot) => {
                this.Aformations = [];
                snapshot.forEach((doc) => {
                  this.$firestore
                    .collection("formateurs")
                    .doc(doc.data()["idFormationFormateur"])
                    .get()
                    .then((snapshot) => {
                      let _d = doc.data();
                      if (snapshot.exists) {
                        _d["Nom Prenom"] =
                          snapshot.data()["nom"] +
                          " " +
                          snapshot.data()["prenom"];
                      } else {
                        _d["Nom Prenom"] = "";
                      }

                      _d["id"] = doc.id;
                      this.Aformations.push(_d);
                    });
                });
              });
            this.$firestore
              .collection("users")
              .get()
              .then((snapshot) => {
                this.clients = [];
                snapshot.forEach((doc) => {
                  var _doc = doc.data();
                  _doc["id"] = doc.id;
                  this.clients.push(_doc);
                });
              });
          }
        })
        .catch((err) => {
          console.log("Error getting documents", err);
        });

      await this.$firestore
        .collection("formateurs")
        .get()
        .then((snapshot) => {
          this.formateurs = [];
          this.formateursF = [];
          snapshot.forEach((doc) => {
            let _d = doc.data();
            _d["id"] = doc.id;
            this.formateurs.push(_d);
            this.formateursF.push({
              text: doc.data()["nom"] + " " + doc.data()["prenom"],
              value: doc.id,
            });
          });
        })
        .catch((err) => {
          console.log("Error getting documents", err);
        });
      await this.$firestore
        .collection("formations")
        .get()
        .then((snapshot) => {
          this.formations = [];
          snapshot.forEach((doc) => {
            this.$firestore
              .collection("formateurs")
              .doc(doc.data()["idFormationFormateur"])
              .get()
              .then((snapshot) => {
                let _d = doc.data();
                _d["Nom Prenom"] = "Error";
                if (snapshot.exists) {
                  _d["Nom Prenom"] =
                    snapshot.data()["nom"] + " " + snapshot.data()["prenom"];
                }
                /*
                for (var item in this.formateursF) {
                  console.log(item)
                  }*/

                //_d["Nom Prenom"] =
                //  snapshot.data()["nom"] + " " + snapshot.data()["prenom"];
                _d["id"] = doc.id;
                this.formations[doc.id] = _d;
              });
          });
        })
        .catch((err) => {
          console.log("Error getting documents", err);
        });
      this.mesformations = [];
      //this.markedDatess = [];
      await this.$firestore
        .collection("inscriptions")
        .where("inscrits", "array-contains", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            var d1 = Date.parse(this.formations[doc.id]["dateFormation"]);
            var d2 = Date.now();
            if (d1 > d2) {
              this.mesformations.push(this.formations[doc.id]);
              //this.daysF.push(this.formations[doc.id]['dateFormation'])
              var _tmp = this.formations[doc.id]["dateFormation"].split("-");

              _tmp = _tmp[2] + "/" + _tmp[1] + "/" + _tmp[0];
              _tmp = _tmp.replace("/0", "/");
              if (_tmp.charAt(0) == "0") {
                _tmp = _tmp.substring(1);
              }
              this.markedDatess.push(_tmp);
            }
          });
        })
        .then(() => {
          console.log();
        });
    }
  },
  metaInfo() {
    return {
      title: "Créer et gérer votre compte OFORIS",
      meta: [
        {
          name: "description",
          content:
            "Accédez à votre compte OFORIS pour gérer vos inscriptions aux évènements à venir ",
        },
        {
          property: "og:title",
          content: "Créer et gérer votre compte OFORIS",
        },
        { property: "og:site_name", content: "Oforis" },
        { property: "og:type", content: "website" },
      ],
    };
  },
  data() {
    return {
      details: "",
      editorOption: {},
      currentNomPrenom: "",
      currentFormateurId: "",
      imageData: null,
      idfomration: "",
      cv: "",
      role: "",
      picture: null,
      uploadValue: 0,
      imageDataFormateur: null,
      pictureFormateur: null,
      uploadValueFormateur: 0,
      formateursF: [],
      fieldsFormations: [
        "dateFormation",
        "nomFormation",
        "publicFormation",
        "Nom Prénom",
      ],
      fieldsFormateurs: ["nom", "prenom", "disciplines", "metier", "expertise"],
      fieldsUtilisateur: [
        "Admin",
        "Entreprise",
        "Entreprise ",
        "Nom",
        "Prénom",
        "Rpps",
        "Salarié",
        "Siret",
        "Taille Ent",
        "Telephone",
        "Id",
        "Email",
      ],
      disciplines: null,
      discipline: "",
      metiers: null,
      metier: "",
      snp: "",
      clients: [],
      userInf: {},
      formations: [],
      Aformations: [],
      formateurs: [],
      mesformations: [],
      daysF: [],
      markedDatess: [],
      currentFormation: -1,
      firebase: firebase,
      expertise: "",
      expertises: null,
      formatFormation: "",
      publicFormation: "",
      objectifFormation: "",
      dureeFormation: "",
      dateFormation: "",
      nomFormation: "",
      idFormationFormateur: "",
      specialiteFormation: "",
      expertiseNew: "",
      nom: "",
      prenom: "",
      metierNew: "",
      disciplineNew: "",
    };
  },
  methods: {
    async desinscription(id) {
      var test = await this.$firestore.collection("inscriptions").doc(id);
      /*
    var removeCapital = test.update({
        inscrits: firebase.firestore.FieldValue.delete()
    });*/
      this.$firestore
        .collection("inscriptions")
        .doc(id)
        .get()
        .then(async (snap) => {
          var tmp = await snap.data()["inscrits"];
          for (var i = 0; i < tmp.length; i++) {
            if (tmp[i] === firebase.auth().currentUser.uid) {
              tmp.splice(i, 1);
            }
          }

          this.mesformations = [];
          await test.update({
            inscrits: tmp,
          });
          await this.$firestore
            .collection("inscriptions")
            .where(
              "inscrits",
              "array-contains",
              firebase.auth().currentUser.uid
            )
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                var d1 = Date.parse(this.formations[doc.id]["dateFormation"]);
                var d2 = Date.now();
                if (d1 > d2) {
                  this.mesformations.push(this.formations[doc.id]);
                  //this.daysF.push(this.formations[doc.id]['dateFormation'])
                  var _tmp =
                    this.formations[doc.id]["dateFormation"].split("-");

                  _tmp = _tmp[2] + "/" + _tmp[1] + "/" + _tmp[0];
                  _tmp = _tmp.replace("/0", "/");
                  if (_tmp.charAt(0) == "0") {
                    _tmp = _tmp.substring(1);
                  }
                  this.markedDatess.push(_tmp);
                }
              });
            });
          /*
           */
        });
    },
    onEditorChange({ html }) {
      this.cv = html;
    },
    onEditorChange2({ html }) {
      this.details = html;
    },
    previewImageFormateur(event) {
      this.uploadValueFormateur = 0;
      this.pictureFormateur = null;
      this.imageDataFormateur = event.target.files[0];
    },

    onUploadImageFormateur() {
      this.pictureFormateur = null;
      const storageRef = firebase
        .storage()
        .ref(
          "images_formateur/" +
            /*`${this.imageData.name}`*/ String(
              Math.floor(Math.random() * 10000000) + 1
            ) +
            `${this.imageDataFormateur.name}`
        )
        .put(this.imageDataFormateur);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValueFormateur =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValueFormateur = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.pictureFormateur = url;
          });
        }
      );
    },
    previewImageFormation(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
    },
    async removeFormation() {
      console.log(this.currentFormation["id"]);
      await this.$firestore
        .collection("formations")
        .doc(this.currentFormation["id"])
        .delete()
        .then(function () {
          console.log("Remove succeeded.");
        })
        .catch(function (error) {
          console.log("Remove failed: " + error.message);
        });
      await this.$firestore
        .collection("formations")
        .get()
        .then((snapshot) => {
          this.Aformations = [];
          snapshot.forEach((doc) => {
            this.$firestore
              .collection("formateurs")
              .doc(doc.data()["idFormationFormateur"])
              .get()
              .then((snapshot) => {
                let _d = doc.data();
                if (snapshot.exists) {
                  _d["Nom Prenom"] =
                    snapshot.data()["nom"] + " " + snapshot.data()["prenom"];
                } else {
                  _d["Nom Prenom"] = "";
                }

                _d["id"] = doc.id;
                this.Aformations.push(_d);
              });
          });
        });
      this.hideModalFormation();
    },
    onUploadImageFormation() {
      this.picture = null;
      const storageRef = firebase
        .storage()
        .ref(
          "images_formation/" +
            /*`${this.imageData.name}`*/ String(
              Math.floor(Math.random() * 10000000) + 1
            ) +
            `${this.imageData.name}`
        )
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.picture = url;
          });
        }
      );
    },
    showModalFormateur() {
      this.$refs["modal-Formateur"].show();
    },
    hideModalFormateur() {
      this.$refs["modal-Formateur"].hide();
    },
    AddFormateur() {
      if (
        this.nom != "" &&
        this.prenom != "" &&
        this.metierNew != "" &&
        this.disciplineNew != "" &&
        this.expertiseNew != "" &&
        this.pictureFormateur != null &&
        this.cv != "" &&
        this.role != ""
      ) {
        let exp = this.$firestore.collection("formateurs");
        let v = {
          nom: this.nom,
          prenom: this.prenom,
          metier: this.metierNew,
          disciplines: this.disciplineNew,
          expertise: this.expertiseNew,
          image: this.pictureFormateur,
          cv: this.cv,
          role: this.role,
        };
        exp.add(v).then(() => {
          this.nom = "";
          this.prenom = "";
          this.metierNew = "";
          this.disciplineNew = "";
          this.expertiseNew = "";
          this.pictureFormateur = null;
          this.cv = "";
          this.role = "";
          this.hideModalFormateur();
          this.$firestore
            .collection("formateurs")
            .get()
            .then((snapshot) => {
              this.formateurs = [];
              this.formateursF = [];
              snapshot.forEach((doc) => {
                let _d = doc.data();
                _d["id"] = doc.id;
                this.formateurs.push(_d);
                this.formateursF.push({
                  text: doc.data()["nom"] + " " + doc.data()["prenom"],
                  value: doc.id,
                });
              });
            })
            .catch((err) => {
              console.log("Error getting documents", err);
            });
        });
      }
    },
    AddFormation() {
      if (
        this.details != "" &&
        this.nomFormation != "" &&
        this.idFormationFormateur != "" &&
        this.specialiteFormation != "" &&
        this.formatFormation != "" &&
        this.publicFormation != "" &&
        this.objectifFormation != "" &&
        this.dureeFormation != "" &&
        this.picture != null &&
        this.idfomration != ""
      ) {
        let exp = this.$firestore.collection("formations");
        if (this.dateFormation == "") {
          this.dateFormation = "";
        }
        let v = {
          details: this.details,
          nomFormation: this.nomFormation,
          dateFormation: this.dateFormation,
          idFormationFormateur: this.idFormationFormateur,
          specialiteFormation: this.specialiteFormation,
          formatFormation: this.formatFormation,
          publicFormation: this.publicFormation,
          objectifFormation: this.objectifFormation,
          dureeFormation: this.dureeFormation,
          image: this.picture,
          idformation: this.idfomration,
        };
        exp
          .add(v)
          .then(() => {
            this.hideModalNewFormation();
            this.$firestore
              .collection("formations")
              .get()
              .then((snapshot) => {
                this.formations = [];
                snapshot.forEach((doc) => {
                  this.$firestore
                    .collection("formateurs")
                    .doc(doc.data()["idFormationFormateur"])
                    .get()
                    .then((snapshot) => {
                      let _d = doc.data();
                      if (snapshot.exists) {
                        _d["Nom Prenom"] =
                          snapshot.data()["nom"] +
                          " " +
                          snapshot.data()["prenom"];
                      } else {
                        _d["Nom Prenom"] = "";
                      }
                      _d["id"] = doc.id;
                      this.formations.push(_d);
                    });
                });
              })
              .catch((err) => {
                console.log("Error getting documents", err);
              });
            this.$firestore
              .collection("formations")
              .get()
              .then((snapshot) => {
                this.Aformations = [];
                snapshot.forEach((doc) => {
                  this.$firestore
                    .collection("formateurs")
                    .doc(doc.data()["idFormationFormateur"])
                    .get()
                    .then((snapshot) => {
                      let _d = doc.data();
                      _d["Nom Prenom"] =
                        snapshot.data()["nom"] +
                        " " +
                        snapshot.data()["prenom"];
                      _d["id"] = doc.id;
                      this.Aformations.push(_d);
                    });
                });
              });
          })
          .catch((err) => {
            console.log("Error getting documents", err);
          });
      }
    },
    showModalNewFormation() {
      this.$refs["modal-NewFormation"].show();
    },
    hideModalNewFormation() {
      this.$refs["modal-NewFormation"].hide();
    },
    updateFormation() {
      let exp = this.$firestore.collection("formations");
      console.log(this.currentFormation);
      let v = {
        details: this.currentFormation.details,
        nomFormation: this.currentFormation.nomFormation,
        dateFormation: this.currentFormation.dateFormation,
        idFormationFormateur: this.currentFormation.idFormationFormateur,
        specialiteFormation: this.currentFormation.specialiteFormation,
        formatFormation: this.currentFormation.formatFormation,
        publicFormation: this.currentFormation.publicFormation,
        objectifFormation: this.currentFormation.objectifFormation,
        dureeFormation: this.currentFormation.dureeFormation,
        image: this.currentFormation.image,
        idformation: this.currentFormation.idformation,
      };
      exp
        .doc(this.currentFormation.id)
        .update(v)
        .then(() => {
          this.$firestore
            .collection("formations")
            .get()
            .then((snapshot) => {
              this.formations = [];
              snapshot.forEach((doc) => {
                this.$firestore
                  .collection("formateurs")
                  .doc(doc.data()["idFormationFormateur"])
                  .get()
                  .then((snapshot) => {
                    let _d = doc.data();
                    _d["Nom Prenom"] =
                      snapshot.data()["nom"] + " " + snapshot.data()["prenom"];
                    _d["id"] = doc.id;
                    this.formations.push(_d);
                  });
              });
            })
            .catch((err) => {
              console.log("Error getting documents", err);
            });
          this.$firestore
            .collection("formations")
            .get()
            .then((snapshot) => {
              this.Aformations = [];
              snapshot.forEach((doc) => {
                this.$firestore
                  .collection("formateurs")
                  .doc(doc.data()["idFormationFormateur"])
                  .get()
                  .then((snapshot) => {
                    let _d = doc.data();
                    _d["Nom Prenom"] =
                      snapshot.data()["nom"] + " " + snapshot.data()["prenom"];
                    _d["id"] = doc.id;
                    this.Aformations.push(_d);
                  });
              });
            });
        })
        .catch((err) => {
          console.log("Error getting documents", err);
        });
    },
    download: function () {
      const data = XLSX.utils.json_to_sheet(this.currentFormation["inscripts"]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(
        wb,
        this.currentFormation["nomFormation"] +
          "_" +
          this.currentFormation["dateFormation"] +
          "inscripts.xlsx"
      );
    },
    addExpertise() {
      if (this.expertise != "") {
        let _exp = this.expertise;
        let exp = this.$firestore.collection("parametres").doc("expertises");
        let v = { [_exp]: _exp };
        exp.set(v, { merge: true }).then(() => {
          this.$firestore
            .collection("parametres")
            .doc("expertises")
            .get()
            .then((snapshot) => {
              this.expertises = snapshot.data();
            });
          this.expertise = "";
        });
      }
    },
    addDiscipline() {
      if (this.discipline != "") {
        let _exp = this.discipline;
        let exp = this.$firestore.collection("parametres").doc("disciplines");
        let v = { [_exp]: _exp };
        exp.set(v, { merge: true }).then(() => {
          this.$firestore
            .collection("parametres")
            .doc("disciplines")
            .get()
            .then((snapshot) => {
              this.disciplines = snapshot.data();
            });
          this.discipline = "";
        });
      }
    },
    async removeFormateur(record) {
      await this.$firestore
        .collection("formateurs")
        .doc(this.currentFormateurId)
        .delete()
        .then(function () {
          console.log("Remove succeeded.");
        })
        .catch(function (error) {
          console.log("Remove failed: " + error.message);
        });
      await this.$firestore
        .collection("formateurs")
        .get()
        .then((snapshot) => {
          this.formateurs = [];
          this.formateursF = [];
          snapshot.forEach((doc) => {
            let _d = doc.data();
            _d["id"] = doc.id;
            this.formateurs.push(_d);
            this.formateursF.push({
              text: doc.data()["nom"] + " " + doc.data()["prenom"],
              value: doc.id,
            });
          });
        });
    },
    eventFormateur(record) {
      this.$refs["modal-sm"].show();
      this.currentNomPrenom = record.nom + " " + record.prenom;
      this.currentFormateurId = record.id;
    },
    myRowClickHandler(record) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      //console.log (record); // This will be the item data for the row
      if (this.snp["admin"]) {
        this.$firestore
          .collection("inscriptions")
          .doc(record.id)
          .get()
          .then((snap) => {
            record["nbinscripts"] = String(snap.data()["inscrits"].length); // will return the collection size
            record["userinscripts"] = snap.data()["inscrits"];
            record["inscripts"] = [];
            this.clients.forEach((element) => {
              if (record["userinscripts"].indexOf(element["id"]) > -1) {
                record["inscripts"].push(element);
              }
            });
            this.currentFormation = record;
            this.showModalFormation();
          })
          .catch(() => {
            record["nbinscripts"] = "0";
            this.currentFormation = record;
            this.showModalFormation();
          });
      }
    },
    showModalNewFormationDuplicate() {
      this.$refs["modal_formations"].hide();
      this.details = this.currentFormation.details;
      this.nomFormation = this.currentFormation.nomFormation;
      this.idFormationFormateur = this.currentFormation.idFormationFormateur;
      this.specialiteFormation = this.currentFormation.specialiteFormation;
      this.formatFormation = this.currentFormation.formatFormation;
      this.publicFormation = this.currentFormation.publicFormation;
      this.objectifFormation = this.currentFormation.objectifFormation;
      this.dureeFormation = this.currentFormation.dureeFormation;
      this.image = this.currentFormation.image;
      this.picture = this.image;
      console.log(this.image);
      this.imageData = this.image;
      this.$refs["modal-NewFormation"].show();
    },

    showModalFormation() {
      this.$refs["modal_formations"].show();
    },
    hideModalFormation() {},
    addMetier() {
      if (this.metier != "") {
        let _exp = this.metier;
        let exp = this.$firestore.collection("parametres").doc("metiers");
        let v = { [_exp]: _exp };
        exp.set(v, { merge: true }).then(() => {
          this.$firestore
            .collection("parametres")
            .doc("metiers")
            .get()
            .then((snapshot) => {
              this.metiers = snapshot.data();
            });
          this.metier = "";
        });
      }
    },
  },
  components: {
    FunctionalCalendar,
    quillEditor,
  },
};
</script>
<style scoped>
body.is-home {
  background-image: None;
  background-size: 60%;
}
.text-nowrap {
  text-align: left !important;
}
.modal-content {
  max-width: 100% !important;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
}
</style>